module.exports = __webpack_public_path__ + "images/upload-image-seachdb27053b0e863795df77c59c6add3ba8.webp";